class GraphSHP {
  constructor(id, attributes, models) {
    this.id = id;
    this.attributes = attributes;
    this.models = models;
  }
}

class GraphGRP {
  constructor(id, attributes, children) {
    this.id = id;
    this.attributes = attributes;
    this.children = children;
  }
}

class GraphTRN {
  constructor(id, attributes, child_id, reserved_id, layer_id, frames) {
    this.id = id;
    this.attributes = attributes;
    this.child_id = child_id;
    this.reserved_id = reserved_id;
    this.layer_id = layer_id;
    this.frames = frames;
  }
}

class Model {
  constructor() {
    this.voxels = Array();
    this.transforms = Array();
  }

  addVoxel({ x, y, z, color_index }) {
    this.voxels.push([x, y, z, color_index]);
  }
}

class VoxFileParser {
  constructor(data, screen) {
    this.data = data;
    this.screen = screen;

    const [header, c] = this.parse(0, this.data, [
      ["id", 4, "CHAR"],
      ["version_number", 4, "INT"],
    ]);

    this._current_frame = 0;

    this.nodes = new Map();
    this.models = new Map();
    this.next_model_id = 0;

    this.parseChunks(this.data.subarray(8));
    this.execute();
    console.log("Finished parsing!")
  }

  execute() {
    // find root nodes (nodes not referenced as children)
    const referenced = new Set();

    for (const node of this.nodes.values()) {
      if (node instanceof GraphTRN) {
        referenced.add(node.child_id);
      }
      if (node instanceof GraphGRP) {
        for (const c of node.children) referenced.add(c);
      }
    }

    // roots = TRN nodes that are not children of anything
    for (const node of this.nodes.values()) {
      if (node instanceof GraphTRN && !referenced.has(node.id)) {
        this._walkNode(node.id, { x: 0, y: 0, z: 0 });
      }
    }
  }

  _walkNode(node_id, transform) {
    const node = this.nodes.get(node_id);
    if (!node) return;

    // -------------------------
    // TRN = transform node
    // -------------------------
    if (node instanceof GraphTRN) {
      for (const frame of node.frames) {
        const t = frame.translation;

        const nextTransform = {
          x: transform.x + t.x,
          y: transform.y + t.y,
          z: transform.z + t.z
        };

        this._walkNode(node.child_id, nextTransform);
      }
    }

    // -------------------------
    // GRP = group node
    // -------------------------
    else if (node instanceof GraphGRP) {
      for (const child_id of node.children) {
        this._walkNode(child_id, transform);
      }
    }

    // -------------------------
    // SHP = model reference
    // -------------------------
    else if (node instanceof GraphSHP) {
      for (const model_id of node.models) {

        const model = this.models.get(model_id);
        if (!model) continue;

        for (const [x, y, z, color_index] of model.voxels) {

          // this.screen.addVoxel(
          //   x + transform.x,
          //   y + transform.y,
          //   z + transform.z,
          //   color_index
          // );
        }
      }
    }
  }

  readInt(d, pos, length) {
    let value = 0;
    for (let i = 0; i < length; ++i) {
      value |= (d[pos + i] & 0xff) << (8 * i);
    }
    return value;
  }

  readCharacters(d, pos, length) {
    const value = String.fromCharCode.apply(
      null,
      d.subarray(pos, pos + length),
    );
    return value;
  }

  parse(c, data, format, dict_subformat) {
    const r = Object();
    for (const i in format) {
      const key = format[i][0];
      const n_bytes = format[i][1];
      const type = format[i][2];

      if (type == "CHAR") {
        r[key] = this.readCharacters(data, c, n_bytes);
      } else if (type == "INT") {
        r[key] = this.readInt(data, c, n_bytes);
      } else if (type == "DICT") {
        r[key] = Object();
        const N = this.readInt(data, c, 4);
        c += 4;
        for (let j = 0; j < N; ++j) {
          const buf_size_key = this.readInt(data, c, 4);
          c += 4;
          const dict_key = this.readCharacters(data, c, buf_size_key);
          c += buf_size_key;

          const buf_size_value = this.readInt(data, c, 4);
          c += 4;

          let dict_value;
          if (dict_subformat == undefined) {
            [dict_value, c] = this.parse(c, data, [
              [key, buf_size_value, "CHAR"],
            ]);
            r[key][dict_key] = dict_value[key];
          } else {
            [dict_value, c] = this.parse(c, data, [dict_subformat[j]]);
            r[key][dict_key] = dict_value[dict_subformat[j][0]];
          }
        }
      }

      c += n_bytes;
    }
    return [r, c];
  }

  parseChunks(data) {
    let cursor = 0;
    let chunk_header;
    [chunk_header, cursor] = this.parse(cursor, data, [
      ["chunk_id", 4, "CHAR"],
      ["chunk_content_length", 4, "INT"],
      ["child_chunks_data_length", 4, "INT"],
    ]);

    const chunk_content = data.subarray(
      cursor,
      cursor + chunk_header["chunk_content_length"],
    );
    cursor += chunk_header["chunk_content_length"];

    const child_chunks_data = data.subarray(
      cursor,
      cursor + chunk_header["child_chunks_data_length"],
    );
    cursor += chunk_header["child_chunks_data_length"];

    let chunk_vars;
    let chunk_cursor = 0;
    if (chunk_header["chunk_id"] == "MAIN") {
    } else if (chunk_header["chunk_id"] == "SIZE") {
      [chunk_vars, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
        ["x", 4, "INT"],
        ["y", 4, "INT"],
        ["z", 4, "INT"],
      ]);
      // We take this as a sign that we are starting a new model
      const m = new Model();
      const model_id = this.next_model_id++;

      this.models.set(model_id, m);
      this.model = m;
      this.current_model_id = model_id;
    } else if (chunk_header["chunk_id"] == "XYZI") {
      [chunk_vars, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
        ["num_voxels", 4, "INT"],
      ]);
      // chunk_cursor += 4;

      for (let i = 0; i < chunk_vars["num_voxels"]; ++i) {
        [chunk_vars[i], chunk_cursor] = this.parse(
          chunk_cursor,
          chunk_content,
          [
            ["x", 1, "INT"],
            ["y", 1, "INT"],
            ["z", 1, "INT"],
            ["i", 1, "INT"],
          ],
        );

        this.model.addVoxel(
          {
            x: chunk_vars[i]["x"],
            y: chunk_vars[i]["z"],
            z: chunk_vars[i]["y"],
            color_index: chunk_vars[i]["i"],
          }
        );
      }
    } else if (chunk_header["chunk_id"] == "RGBA") {
      const num_colors = 255;
      let colors;
      for (let i = 1; i < num_colors + 1; ++i) {
        [colors, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
          ["r", 1, "INT"],
          ["g", 1, "INT"],
          ["b", 1, "INT"],
          ["a", 1, "INT"],
        ]);
        this.screen.colormap.newColor(i, colors["r"] / 255, colors["g"] / 255, colors["b"] / 255, 1.0 - colors["a"] / 255);
      }
    } else if (chunk_header["chunk_id"] == "MATL") {
      [chunk_vars, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
        ["material_id", 4, "INT"],
        ["material_properties", 0, "DICT"],
      ]);
    } else if (chunk_header["chunk_id"] == "nTRN") {

      [chunk_vars, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
        ["node_id", 4, "INT"],
        ["node_attributes", 0, "DICT"],
        ["child_node_id", 4, "INT"],
        ["reserved_id", 4, "INT"],
        ["layer_id", 4, "INT"],
        ["num_frames", 4, "INT"],
      ]);

      let frames = [];

      for (let i = 0; i < chunk_vars.num_frames; ++i) {

        let frame_vars;

        [frame_vars, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
          ["frame_attributes", 0, "DICT"],
        ]);

        let translation = { x: 0, y: 0, z: 0 };

        if ("_t" in frame_vars.frame_attributes) {
          const [x, y, z] = frame_vars.frame_attributes._t
            .split(" ")
            .map(v => parseInt(v, 10));

          translation = { x, y, z };
        }

        frames.push({
          attributes: frame_vars.frame_attributes,
          translation
        });
      }

      this.nodes.set(
        chunk_vars.node_id,
        new GraphTRN(
          chunk_vars.node_id,
          chunk_vars.node_attributes,
          chunk_vars.child_node_id,
          chunk_vars.reserved_id,
          chunk_vars.layer_id,
          frames
        )
      );
    } else if (chunk_header["chunk_id"] == "nGRP") {

      [chunk_vars, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
        ["node_id", 4, "INT"],
        ["node_attributes", 0, "DICT"],
        ["num_children", 4, "INT"],
      ]);

      let children = [];

      for (let i = 0; i < chunk_vars.num_children; ++i) {

        let child;

        [child, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
          ["child_id", 4, "INT"],
        ]);

        children.push(child.child_id);
      }

      this.nodes.set(
        chunk_vars.node_id,
        new GraphGRP(
          chunk_vars.node_id,
          chunk_vars.node_attributes,
          children
        )
      );
    } else if (chunk_header["chunk_id"] == "nSHP") {

      [chunk_vars, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
        ["node_id", 4, "INT"],
        ["node_attributes", 0, "DICT"],
        ["num_models", 4, "INT"],
      ]);

      let models = [];

      for (let i = 0; i < chunk_vars.num_models; ++i) {

        let model_data;

        [model_data, chunk_cursor] = this.parse(chunk_cursor, chunk_content, [
          ["model_id", 4, "INT"],
          ["model_attributes", 0, "DICT"],
        ]);

        models.push(model_data.model_id);
      }

      this.nodes.set(
        chunk_vars.node_id,
        new GraphSHP(
          chunk_vars.node_id,
          chunk_vars.node_attributes,
          models
        )
      );
    } else {
      console.log("missing implementation for", chunk_header);
    }

    // Now the child chunks
    let child_cursor = 0;
    if (child_chunks_data.length > 0) {
      while (child_cursor < child_chunks_data.length) {
        const r = this.parseChunks(child_chunks_data.subarray(child_cursor));
        child_cursor += r;
      }
    }

    return cursor;
  }
}

export { VoxFileParser };
